export default {
  validation: {
    min: 'The minimum length should be {min}',
    max: 'The maximum length should be {max}',
    required: 'This field is required',
    regex: 'Please input valid data',
    email: 'Please, input a valid email',
    phoneNumber: 'Please, input a valid phone number',
    sameValueAs: 'This field should have the same as {sameValueAs}',
    shouldBeTrue: 'This field is required to be checked',
    checked: '',
  },
}
